const getItemFromStorage = (itemName) => {
    const local = localStorage.getItem(itemName);
    if(local)
    {
        return local
    }
    
    const session = sessionStorage.getItem(itemName)
    if(session){
        return session;
    }
    
    return undefined;
}

const setItemToStorage = (itemName, itemValue, seSouvenir) => {
    if(seSouvenir == "1")
    {
        localStorage.setItem(itemName, itemValue)
    }else{
        sessionStorage.setItem(itemName, itemValue)
    }
}

const HabilitationService = {
    
    seSouvenir: getItemFromStorage("seSouvenir"),
    
    habilitations: getItemFromStorage("habilitations") ? JSON.parse(getItemFromStorage("habilitations")) : undefined,
    token: getItemFromStorage("token"),
    tokenValidUntil: getItemFromStorage("tokenValidUntil"),
    refreshToken: getItemFromStorage("refreshToken"),

    modeDebug: getItemFromStorage("modeDebug") == 1 ? 1 : 0,

    saveCompleteSet : function (dataFromDb) {
        this.setSeSouvenir(dataFromDb.seSouvenir);
        this.setToken(dataFromDb.token);
        this.setTokenValidUntil(dataFromDb.tokenValidUntil);
        this.setRefreshToken(dataFromDb.refreshToken);
        this.setHabilitations(dataFromDb.habilitations);
    },
    
    setSeSouvenir: function (seSouvenir) {
        this.seSouvenir = seSouvenir ? "1" : "0";
        setItemToStorage("seSouvenir", seSouvenir ? "1" : "0", this.seSouvenir);
    },

    setHabilitations: function (habilitations) {
        this.habilitations = habilitations;
        setItemToStorage("habilitations", JSON.stringify(habilitations), this.seSouvenir);
    },
    setToken: function (tok) {
        this.token = tok;
        setItemToStorage("token", tok, this.seSouvenir);
    },
    setTokenValidUntil: function (timeLimit) {
        this.tokenValidUntil = timeLimit;
        setItemToStorage("tokenValidUntil", timeLimit, this.seSouvenir);
    },
    setRefreshToken: function (tok) {
        this.refreshToken = tok;
        setItemToStorage("refreshToken", tok, this.seSouvenir);
    },

    setModeDebug: function (modeDebug) {
        this.modeDebug = modeDebug ? "1" : "0";
        setItemToStorage("modeDebug", modeDebug ? "1" : "0", this.seSouvenir);
    },

    disconnect: function () {
        localStorage.clear();
        sessionStorage.clear();

        delete this.habilitations;
        delete this.token;
        delete this.tokenValidUntil;
        delete this.refreshToken;

        delete this.modeDebug;
    }
};

export default HabilitationService;